import { render, staticRenderFns } from "./SampleCohortQueryBanner.vue?vue&type=template&id=9104795e"
import script from "./SampleCohortQueryBanner.vue?vue&type=script&lang=js"
export * from "./SampleCohortQueryBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports